const controller = function (
	$auth, 
	$cordovaBarcodeScanner, 
	$interval,
	$ionicHistory,
	$ionicPlatform,
	$rootScope, 
	$scope,
	$state,
	$window,
	$timeout, 
	Customer,
	Push,
	User,
	Socket,
	Support,
) {
	"ngInject";

	var vm = this;

	vm.scanning = false;
	vm.busy = false;
	vm.scannable = true;
	vm.keyboard = false;

	$rootScope.user = false;
	
	Socket.unbind();

	vm.submit = function() {
		authenticate();
	}

	vm.login = function($event) {
		$event.preventDefault();
		Customer.flush();
		authenticate();
	}

	vm.scanBarcode = function() {
		vm.email = undefined;
		vm.password = undefined;
		vm.barcode = undefined;
		vm.scanning = true;
		if (window.cordova) {
			$cordovaBarcodeScanner.scan().then(function(result) {
				vm.barcode = result.text;
				authenticate();
			});
		} else {
			var code = $window.prompt('Enter code');
			if (code !== null) {
				vm.barcode = code;
				authenticate();
			}
		}
	}

	window.addEventListener('native.keyboardhide', function(){
		vm.keyboard = false;
		$scope.$apply();
	});

	window.addEventListener('native.keyboardshow', function(){
		vm.keyboard = true;
		$scope.$apply();
	});



	var authenticate = function() {
		vm.busy = true;
		var credentials = {
			email: vm.email,
			password: vm.password,
			barcode: vm.barcode
		}

		$auth.login(credentials).then(data => {
			return User.get();
		}).then(user => {
			// $ionicPlatform.ready(function() {
			// 	if (window.cordova) {
			// 		Push.init();
			// 	}
			// });

			vm.busy = false;
			$ionicHistory.nextViewOptions({
				disableAnimate: true,
				disableBack: true
			});
			$state.go('tab.home');
		}).catch(e => {
			console.log(e);
			vm.animate = true;

			$timeout(() => {
				vm.animate = false;
			}, 1000);
		}).finally(() => {
			vm.busy = false;
		});
	}
};

export default controller;


// WEBPACK FOOTER //
// ./app/components/login/login.controller.js